import WeatherIcon from "./WeatherIcon";
import state from "./state";
import { useSnapshot } from "valtio";

export default function Forecast(props) {
  const snape = useSnapshot(state);

  function getForecastDay() {
    let date = new Date(props.data.dt * 1000);
    let day = date.getDay();
    let weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekDays[day];
  }

  function getFahrenheit(temp) {
    return (temp * 9) / 5 + 32;
  }

  function roundTemp(temp) {
    return Math.round(temp);
  }

  if (snape.unit === "celsius") {
    return (
      <div className="Forecast day-forecast text-center">
        <div>{getForecastDay()}</div>
        <WeatherIcon
          icon={props.data.weather[0].icon}
          size={30}
          color="white"
        />
        <div className="temp-min-max">
          {roundTemp(props.data.temp.max)}º / {roundTemp(props.data.temp.min)}º
        </div>
      </div>
    );
  } else {
    let fahrenheit = {
      min: getFahrenheit(props.data.temp.min),
      max: getFahrenheit(props.data.temp.max),
    };

    return (
      <div className="Forecast">
        <div>{getForecastDay()}</div>
        <WeatherIcon
          icon={props.data.weather[0].icon}
          size={30}
          color="white"
        />
        <div className="temp-min-max">
          {roundTemp(fahrenheit.max)}º / {roundTemp(fahrenheit.min)}º
        </div>
      </div>
    );
  }
}
